export const config = {
  managerName: "Paul Whyte",
  phoneNumber: "618-406-9887",
  emailServerToEmail: "kchallofallon.events@gmail.com",
  emailServerUrl: "/.netlify/functions/contact",
  facebookLink: "https://www.facebook.com/KnightsOfColumbus4239",
  facebookAppId: 538708347039764,
  facebookPageId: 460408880684029,
}

export const PAGE_URLS = {
  HOME: "/",
  ABOUT_US: "/about-us",
  CONTACT: "/contact",
  FACILITIES: "/facilities",
  ACTIVITIES: "/activities",
  SERVICES: "/services",
  GALLERY: "/gallery",
  WEDDING_BROCHURE: "/wedding-brochure.pdf",
  LENT_FISHFRY_MENU: "/lent_fishfry_menu.png",
  FISHFRY_LUNCH_MENU: "/fish-fry-lunch-menu.png",
  FISHFRY_MENU: "/fish-fry-menu.png",
  WEEKLY_MENU: "/weekly-menu.png",
  BINGO_MENU: "/bingo-menu.png",
}

export const SERVICE_IDS = {
  WEDDING_RECEPTIONS: "wedding-receptions",
  CORPORATE_FUNCTIONS: "corporate-functions",
  HAPPIER_HOLIDAYS: "happier-holidays",
  FUNERAL_SERVICES: "funeral-services",
  FUNDRAISERS: "fundraisers",
  BIRTHDAY_PARTIES: "birthday-parties",
}

export const SERVICE_URLS = {
  WEDDING_RECEPTIONS: `/services/#${SERVICE_IDS.WEDDING_RECEPTIONS}`,
  CORPORATE_FUNCTIONS: `/services/#${SERVICE_IDS.CORPORATE_FUNCTIONS}`,
  HAPPIER_HOLIDAYS: `/services/#${SERVICE_IDS.HAPPIER_HOLIDAYS}`,
  FUNERAL_SERVICES: `/services/#${SERVICE_IDS.FUNERAL_SERVICES}`,
  FUNDRAISERS: `/services/#${SERVICE_IDS.FUNDRAISERS}`,
  BIRTHDAY_PARTIES: `/services/#${SERVICE_IDS.BIRTHDAY_PARTIES}`,
}
